<div class="icon_row" on:click>
    <slot></slot>
</div>

<style>
    .icon_row{
        display: flex;
        flex-direction: row;
        padding-left: 15px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
</style>